import React from "react";
import SocialConnect from "../UI/SocialConnect";
import "./style.css";

const Footer = (props) => {
  return (
    <center>
      <div className="container">
        <div
          className="flexRow flexCol align-center"
          style={{
            margin: "30px 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="mtb-10">
            <SocialConnect />
          </div>
          {/*  <div className="footerMenus mtb-10">
          <nav>
            <a href="#">Home</a>
            <a href="#">About</a>
            <a href="#">Portfolios</a>
            <a href="#">Contact</a>
          </nav>
        </div> */}
          {/*  <div className="conversationContainer  mtb-10">
          <img src="https://img.icons8.com/cute-clipart/50/000000/chat.png" />
        </div> */}
        </div>
      </div>
    </center>
  );
};

export default Footer;
